/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Email_Confirmation_FailedInputs */

const nl_auth_api_errors_email_confirmation_failed = /** @type {(inputs: Auth_Api_Errors_Email_Confirmation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres bevestigen is mislukt. De link is mogelijk verlopen of ongeldig.`)
};

/**

* @param {Auth_Api_Errors_Email_Confirmation_FailedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_email_confirmation_failed = /** @type {((inputs?: Auth_Api_Errors_Email_Confirmation_FailedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Email_Confirmation_FailedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_email_confirmation_failed(inputs)
});
export { auth_api_errors_email_confirmation_failed as "auth.api_errors.email_confirmation_failed" }